module.exports = __webpack_public_path__ + "static/media/pain_img.e836127c.png";